import PropTypes from 'prop-types'
import { Box } from '@mui/material'

import styles from './styles'

const FixedBottomWrapper = ({ children, fullWidth, zIndexModal }) => {
  const classes = {
    ...styles.fixedBottomWrapper,
    ...(fullWidth ? styles.hasFullWidth : {}),
    ...(zIndexModal ? styles.zIndexModal : {}),
  }

  return <Box sx={classes}>{children}</Box>
}

FixedBottomWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
  zIndexModal: PropTypes.bool,
}

export default FixedBottomWrapper
